import React from 'react';

import { AccountNumberInput } from 'components';
import { FormFieldProps, GetFieldValidatorFn } from 'types';

import { getTCommon, useTFeature } from '../fields.utils';
import { getBaseFieldValidator } from '../form.validators';

export const Field: React.FC<FormFieldProps> = ({
  name,
  required = false,
  disabled = false,
}) => {
  const { t } = useTFeature();

  return (
    <AccountNumberInput
      name={name}
      label={t('fields.card.label')}
      fullWidth
      required={required}
      disabled={disabled}
    />
  );
};

export const getValidator: GetFieldValidatorFn = ({ required }) => {
  const tCommon = getTCommon();
  return getBaseFieldValidator({ required }).matches(
    /^[0-9]{16}$/,
    tCommon('errors.invalid'),
  );
};
